import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "cdes-page" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 mb-3" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md" }
const _hoisted_6 = { class: "col-12 mb-3" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-lg-6" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "mb-3" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-md" }
const _hoisted_14 = { class: "mb-3" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-md" }
const _hoisted_17 = { class: "mb-3" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-md" }
const _hoisted_20 = ["aria-labelledby"]
const _hoisted_21 = { class: "d-flex flex-row align-items-center" }
const _hoisted_22 = { class: "addDeputyList" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "mb-3" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-md" }
const _hoisted_29 = ["id", "onUpdate:modelValue", "disabled"]
const _hoisted_30 = { class: "col-lg-6" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "mb-3" }
const _hoisted_33 = { class: "row" }
const _hoisted_34 = { class: "col-md" }
const _hoisted_35 = ["id", "onUpdate:modelValue", "disabled"]
const _hoisted_36 = { class: "mb-3" }
const _hoisted_37 = { class: "row" }
const _hoisted_38 = { class: "col-md" }
const _hoisted_39 = ["id", "onUpdate:modelValue", "title", "disabled"]
const _hoisted_40 = { class: "mb-3" }
const _hoisted_41 = { class: "row" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-9-em" }, null, -1)
const _hoisted_43 = { class: "col-md" }
const _hoisted_44 = { class: "form-check" }
const _hoisted_45 = ["id", "onUpdate:modelValue", "disabled"]
const _hoisted_46 = ["for"]
const _hoisted_47 = { class: "mb-3" }
const _hoisted_48 = { class: "row" }
const _hoisted_49 = { class: "col-md" }
const _hoisted_50 = ["disabled"]
const _hoisted_51 = ["disabled"]
const _hoisted_52 = {
  type: "button",
  class: "btn btn-primary",
  "data-bs-dismiss": "modal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Label = _resolveComponent("Label")!
  const _component_Select = _resolveComponent("Select")!
  const _component_MainParticipantDropDown = _resolveComponent("MainParticipantDropDown")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_CheckBox = _resolveComponent("CheckBox")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_RoleConflictPage = _resolveComponent("RoleConflictPage")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _directive_validation_form = _resolveDirective("validation-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("form", {
      class: "p-3",
      onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)), ["prevent"]))
    }, [
      _createElementVNode("fieldset", null, [
        _createElementVNode("legend", null, _toDisplayString(_ctx.$t("general.organisation")), 1),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_Label, {
                for: _ctx.$id('organisation'),
                class: "col-md-9-em col-form-label text-md-end"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("general.organisation")), 1)
                ]),
                _: 1
              }, 8, ["for"]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_Select, {
                  class: _normalizeClass(this.getOrganisationCss()),
                  mode: "flex",
                  id: _ctx.$id('organisation'),
                  selectClass: "form-select",
                  options: _ctx.organisationOptions,
                  sort: "",
                  modelValue: _ctx.editInfo.organisationId,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editInfo.organisationId) = $event)),
                  disabled: _ctx.disabled
                }, null, 8, ["class", "id", "options", "modelValue", "disabled"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.newRole())),
              disabled: _ctx.disabled || _ctx.editInfo.organisationId == null
            }, _toDisplayString(_ctx.$t('project.participation.edit.addRole')), 9, _hoisted_7)
          ])
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editInfo.participations, (participation) => {
        return (_openBlock(), _createElementBlock("fieldset", {
          key: participation.participationId,
          ref: _ctx.setRoleRef
        }, [
          _createElementVNode("legend", null, _toDisplayString(_ctx.$t("project.participation.edit.roleHeading", { role: _ctx.cdesRoles.get(participation.cdesRoleId)?.name })), 1),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_Label, {
                      for: _ctx.$id(participation.participationId + 'role'),
                      class: "col-md-9-em col-form-label text-md-end"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("general.role")), 1)
                      ]),
                      _: 2
                    }, 1032, ["for"]),
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_Select, {
                        class: _normalizeClass(this.getRoleCss(participation)),
                        mode: "flex",
                        id: _ctx.$id(participation.participationId + 'role'),
                        selectClass: "form-select",
                        options: _ctx.roleOptions,
                        sort: "",
                        modelValue: participation.cdesRoleId,
                        "onUpdate:modelValue": ($event: any) => ((participation.cdesRoleId) = $event),
                        disabled: _ctx.disabled
                      }, null, 8, ["class", "id", "options", "modelValue", "onUpdate:modelValue", "disabled"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_Label, {
                      for: _ctx.$id(participation.participationId + 'mainParticipant'),
                      class: "col-md-9-em col-form-label text-md-end"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("general.mainParticipant")), 1)
                      ]),
                      _: 2
                    }, 1032, ["for"]),
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_MainParticipantDropDown, {
                        disabled: _ctx.disabled,
                        personInfos: _ctx.personInfos,
                        editInfo: this.editInfo,
                        modelValue: participation.mainParticipantOrganisationPersonId,
                        "onUpdate:modelValue": ($event: any) => ((participation.mainParticipantOrganisationPersonId) = $event)
                      }, null, 8, ["disabled", "personInfos", "editInfo", "modelValue", "onUpdate:modelValue"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_Label, {
                      for: _ctx.$id(participation.participationId + 'deputy'),
                      class: "col-md-9-em col-form-label text-md-end"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("general.deputy")), 1)
                      ]),
                      _: 2
                    }, 1032, ["for"]),
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_MultiSelect, {
                        id: _ctx.$id(participation.participationId + 'deputy'),
                        class: "form-control",
                        modelValue: participation.deputyOrganisationPersonIds,
                        "onUpdate:modelValue": ($event: any) => ((participation.deputyOrganisationPersonIds) = $event),
                        itemKey: a => a.organisationPerson.id,
                        itemValue: a => a.organisationPerson.id,
                        itemLabel: a => _ctx.renderPerson(a),
                        disabled: _ctx.disabled,
                        options: _ctx.deputies(participation),
                        sort: ""
                      }, {
                        dropdown: _withCtx(({ buttonId, add }) => [
                          _createElementVNode("div", {
                            class: "dropdown-menu",
                            "aria-labelledby": buttonId
                          }, [
                            _createElementVNode("li", _hoisted_21, [
                              _createVNode(_component_TextInput, {
                                class: "ms-3 deputyAddFilter",
                                modelValue: this.deputyAddFilter,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((this.deputyAddFilter) = $event)),
                                mode: "flex",
                                label: this.$t('general.filter')
                              }, null, 8, ["modelValue", "label"]),
                              _createVNode(_component_CheckBox, {
                                class: "ms-2",
                                mode: "flex",
                                modelValue: this.offerParticipationsOfAllOrganisations,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((this.offerParticipationsOfAllOrganisations) = $event)),
                                label: this.$t('project.participation.list.deputy.offerParticipationsOfAllOrganisations')
                              }, null, 8, ["modelValue", "label"])
                            ]),
                            _createElementVNode("li", _hoisted_22, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.getDeputyOptions(participation), (consortiumPersonInfo) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "d-flex flex-column addDeputyList",
                                  key: consortiumPersonInfo.organisationPerson.id
                                }, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item",
                                    onClick: ($event: any) => (add(consortiumPersonInfo))
                                  }, [
                                    (this.offerParticipationsOfAllOrganisations)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(this.getPersonOrganisationString(consortiumPersonInfo)), 1))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(this.getPersonOrganisationString(consortiumPersonInfo)), 1))
                                  ], 8, _hoisted_23)
                                ]))
                              }), 128))
                            ])
                          ], 8, _hoisted_20)
                        ]),
                        _: 2
                      }, 1032, ["id", "modelValue", "onUpdate:modelValue", "itemKey", "itemValue", "itemLabel", "disabled", "options"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_Label, {
                      for: _ctx.$id(participation.participationId + 'contractor'),
                      class: "col-md-9-em col-form-label text-md-end"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("general.contractorNumber")), 1)
                      ]),
                      _: 2
                    }, 1032, ["for"]),
                    _createElementVNode("div", _hoisted_28, [
                      _withDirectives(_createElementVNode("input", {
                        id: _ctx.$id(participation.participationId + 'contractor'),
                        class: "form-control",
                        "onUpdate:modelValue": ($event: any) => ((participation.customerId) = $event),
                        disabled: _ctx.disabled,
                        type: "text",
                        maxlength: "6"
                      }, null, 8, _hoisted_29), [
                        [_vModelText, participation.customerId]
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createVNode(_component_Label, {
                      for: _ctx.$id(participation.participationId + 'comment'),
                      class: "col-md-9-em col-form-label text-md-end"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("general.comment")), 1)
                      ]),
                      _: 2
                    }, 1032, ["for"]),
                    _createElementVNode("div", _hoisted_34, [
                      _withDirectives(_createElementVNode("textarea", {
                        id: _ctx.$id(participation.participationId + 'comment'),
                        class: "form-control",
                        rows: "3",
                        "onUpdate:modelValue": ($event: any) => ((participation.comment) = $event),
                        disabled: _ctx.disabled,
                        maxlength: "255"
                      }, null, 8, _hoisted_35), [
                        [_vModelText, participation.comment]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _createVNode(_component_Label, {
                      for: _ctx.$id(participation.participationId + 'email'),
                      class: "col-md-9-em col-form-label text-md-end"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("general.email.email")), 1)
                      ]),
                      _: 2
                    }, 1032, ["for"]),
                    _createElementVNode("div", _hoisted_38, [
                      _withDirectives(_createElementVNode("input", {
                        id: _ctx.$id(participation.participationId + 'email'),
                        type: "email",
                        class: "form-control",
                        "onUpdate:modelValue": ($event: any) => ((participation.attachmentEmailAddress) = $event),
                        "data-bs-toggle": "tooltip",
                        title: _ctx.$t('project.participation.edit.emailTooltip'),
                        disabled: _ctx.disabled,
                        maxlength: "80"
                      }, null, 8, _hoisted_39), [
                        [_vModelText, participation.attachmentEmailAddress]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _hoisted_42,
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("div", _hoisted_44, [
                        _withDirectives(_createElementVNode("input", {
                          id: _ctx.$id(participation.participationId + 'mail'),
                          type: "checkbox",
                          class: "form-check-input",
                          "onUpdate:modelValue": ($event: any) => ((participation.mailFlag) = $event),
                          disabled: _ctx.disabled
                        }, null, 8, _hoisted_45), [
                          [_vModelCheckbox, participation.mailFlag]
                        ]),
                        _createElementVNode("label", {
                          class: "form-check-label",
                          for: _ctx.$id(participation.participationId + 'mail')
                        }, _toDisplayString(_ctx.$t('project.participation.edit.mailFlag')), 9, _hoisted_46)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _createVNode(_component_Label, {
                      for: _ctx.$id(participation.participationId + 'allowedSubProjects'),
                      class: "col-md-9-em col-form-label text-md-end"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("general.allowedSubProjects")), 1)
                      ]),
                      _: 2
                    }, 1032, ["for"]),
                    _createElementVNode("div", _hoisted_49, [
                      _createVNode(_component_MultiSelect, {
                        id: _ctx.$id(participation.participationId + 'allowedSubProjects'),
                        class: "form-control",
                        "data-bs-toggle": "tooltip",
                        title: _ctx.$t('project.participation.edit.allowedSubProjectsTooltip'),
                        modelValue: participation.allowedSubProjectIds,
                        "onUpdate:modelValue": ($event: any) => ((participation.allowedSubProjectIds) = $event),
                        itemKey: a => a.id,
                        itemValue: a => a.id,
                        itemLabel: a => '(' + a.code + (a.number != null ? (a.number + ' ') : '') + ') ' + a.name,
                        disabled: _ctx.disabled || !_ctx.withRestrictions,
                        options: _ctx.selectInfo.value.subProjects,
                        getRemovalError: (subProjectId) => this.getRemovalError(subProjectId, participation.participationId),
                        sort: ""
                      }, null, 8, ["id", "title", "modelValue", "onUpdate:modelValue", "itemKey", "itemValue", "itemLabel", "disabled", "options", "getRemovalError"])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ], 512))
      }), 128)),
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          type: "submit",
          class: "btn btn-primary m-1",
          disabled: this.saveDisabled
        }, _toDisplayString(_ctx.$t('general.save')), 9, _hoisted_50),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary m-1",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args))),
          disabled: _ctx.disabled
        }, _toDisplayString(_ctx.$t('general.cancel')), 9, _hoisted_51)
      ])
    ], 544), [
      [_directive_validation_form]
    ]),
    _createVNode(_component_Dialog, {
      ref: "roleConflictPage",
      lazy: "",
      title: _ctx.$t('roleConflictInfo.dialogTitle'),
      extraClasses: "roleConflictDialog modal-xl"
    }, {
      buttons: _withCtx(() => [
        _createElementVNode("button", _hoisted_52, _toDisplayString(_ctx.$t('general.abort')), 1),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary",
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.doSave && _ctx.doSave(...args)))
        }, _toDisplayString(_ctx.$t('general.save')), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_RoleConflictPage, {
          roleConflictInfo: this.roleConflictInfo
        }, null, 8, ["roleConflictInfo"])
      ]),
      _: 1
    }, 8, ["title"])
  ]))
}